export default [
  {
    path: '/courses/:name/list',
    name: 'allCourses',
    component: () => import('@/pages/AllCourses'),
  },
  {
    path: '/layout/all-courses',
    name: 'layout-all-courses',
    component: () => import('@/pages/Debug'),
  },
  {
    path: '/course/:slug/:id',
    name: 'course',
    props: true,
    component: () => import('@/pages/Course'),
  },
]
